"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCatalogCategory = exports.setCatalogCategoryGroup = exports.setCatalogSeries = exports.setCatalogSeriesType = void 0;
const typesafe_actions_1 = require("typesafe-actions");
const consts_1 = require("./consts");
exports.setCatalogSeriesType = (0, typesafe_actions_1.createAction)(consts_1.SET_CATALOG_SERIES_TYPE)();
exports.setCatalogSeries = (0, typesafe_actions_1.createAction)(consts_1.SET_CATALOG_SERIES)();
exports.setCatalogCategoryGroup = (0, typesafe_actions_1.createAction)(consts_1.SET_CATALOG_CATEGORY_GROUP)();
exports.setCatalogCategory = (0, typesafe_actions_1.createAction)(consts_1.SET_CATALOG_CATEGORY)();
